var exports = {
  "X": "ConnectionsTab.module__confirmDescription___aXRLcF",
};

module.exports = exports;
